import { ApplicationWithDetails } from '../../../types';
import { PrinterDetails } from './PrinterDetails/PrinterDetails';
import { PrinterInstructions } from './PrinterInstructions/PrinterInstructions';
import { PrinterKnowledgeBase } from './PrinterKnowledgeBase/PrinterKnowledgeBase';

export const Printer: ApplicationWithDetails = {
	id: `11ECF3AAF97D059CB9706F21406ECD74`,
	name: `Принтер Додо`,
	description: `Печать этикеток на термопринтере.`,
	descriptionLong: `Приложение поддерживает печать этикеток на станции упаковки и печать маркировок в холодном цехе.Печать этикеток упрощает процесс упаковки, так как заменяет написание номера заказа вручную. Этикетка на упаковке содержит номер заказа и наименования соусов для курьера, а также даёт клиенту полную информацию о составе продукта и сроках изготовления/годности в соответствии с законодательством. Вертикальная этикетка показывает, что контроль качества пройден. А ещё в вертикальном шаблоне этикетки на QR коде можно разместить маркетинговую информацию или форму обратной связи. \n\nПринтер печати маркировок заменяет ручную маркировку, сокращает время и ошибки, связанные с человеческим фактором (например, нечитаемые сроки годности). Сотруднику не нужно постоянно обращаться к таблице ингредиентов, так как принтер содержит сроки годности, аналогичные срокам, прописанным в стандартах.`,
	logoUrl: `https://cdn.dodostatic.net/static/marketplace/printer/logo-n`,
	logoBgr: `https://cdn.dodostatic.net/static/marketplace/printer/bgr`,
	sliders: [
		`https://cdn.dodostatic.net/static/marketplace/printer/slider1`,
		`https://cdn.dodostatic.net/static/marketplace/printer/slider2`,
		`https://cdn.dodostatic.net/static/marketplace/printer/slider3`,
		`https://cdn.dodostatic.net/static/marketplace/printer/slider4`,
		`https://cdn.dodostatic.net/static/marketplace/printer/slider5`,
		// 'https://cdn.dodostatic.net/static/marketplace/printer/slider6',
	],
	// eslint-disable-next-line sonarjs/no-duplicate-string
	webSiteUrl: ``,
	supportUrl: `https://play.google.com/store/apps/details?id=com.dodopizza.foregroundprinter&hl=ru&gl=US`,
	redirectUrl: ``,
	contactEmail: `support@dodopizza.com`,
	supportEmail: ``,
	categories: [`Производство`, `Принтер этикеток`, `Холодный цех`, `Упаковка`],
	countries: [`Все`],
	languages: [`Русский`, `English`],
	conceptions: [`Dodo Pizza`, `Drinkit`, `Doner42`],
	type: `Приложение`,
	price: `Бесплатно`,
	version: `1.0`,
	developer: `Dodo Brands`,
	plans: null,
	instructions: PrinterInstructions,
	details: PrinterDetails,
	knowledgeBase: PrinterKnowledgeBase,
	isExternal: false,
	showInstruction: false,
	versionHistory: null,
	goToApp: false,
};
